import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface VideoChatState {
  is_calling: boolean;
  data?: {
    group?: number | null;
    action: "call";
    data: {
      connection_id?: string | null;
    };
  };
}

const initialState: VideoChatState = {
  is_calling: false,
  data: {
    group: null,
    action: "call",
    data: {
      connection_id: null,
    },
  },
};

const videoChatSlice = createSlice({
  name: 'videoChat',
  initialState,
  reducers: {
    callVideoChat(state, action: PayloadAction<VideoChatState>) {
      state.is_calling = true;
      state.data = action.payload.data;
    },
    cancelVideoChat(state, action: PayloadAction<VideoChatState>) {
      state.is_calling = false;
      state.data = action.payload.data;
    }
  },
});

export const {callVideoChat, cancelVideoChat} = videoChatSlice.actions;

export default videoChatSlice.reducer;
